<template>
  <v-container class="my-1">
    <v-card>
      <v-card-title class="page-head">
        <div class="ph-left">
          <div class="ph-icon"><v-icon color="#00695c">mdi-map-marker-radius</v-icon></div>
          <div>
            <div class="ph-title">Districts</div>
            <div class="ph-sub">Manage districts and regions</div>
          </div>
        </div>
        <v-spacer />
        <v-text-field
          v-model="search"
          prepend-inner-icon="mdi-magnify"
          placeholder="Search..."
          outlined
          dense
          hide-details
          class="ph-search"
        />
        <v-btn class="ph-btn" @click="formNuevo()">
          <v-icon left small>mdi-plus</v-icon>
          New District
        </v-btn>
      </v-card-title>

      <v-data-table
        class="elevation-0"
        :search="search"
        :headers="headers"
        :items="districts"
        item-key="id"
        :items-per-page="-1"
        :footer-props="{ 'items-per-page-options': [10, 25, 50, -1], 'items-per-page-text': 'Rows per page' }"
      >
        <template v-slot:item.index="{ index }">
          <span class="cell-muted">{{ index + 1 }}</span>
        </template>

        <template v-slot:item.district_name="{ item }">
          <span class="cell-name">{{ item.district_name }}</span>
        </template>

        <template v-slot:item.region="{ item }">
          <v-chip v-if="item.region" small outlined color="teal">{{ item.region }}</v-chip>
          <span v-else class="cell-muted">—</span>
        </template>

        <template v-slot:item.status="{ item }">
          <v-chip
            small
            :color="item.status == 1 ? '#e8f5e9' : '#ffebee'"
            :text-color="item.status == 1 ? '#2e7d32' : '#c62828'"
          >
            <span class="status-dot" :style="{ background: item.status == 1 ? '#2e7d32' : '#c62828' }"></span>
            {{ item.status == 1 ? 'Active' : 'Inactive' }}
          </v-chip>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon small color="#2e7d32" v-bind="attrs" v-on="on" @click="formEditar(item)">
                <v-icon small>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Edit district</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                small
                :color="item.status == 1 ? '#c62828' : '#2e7d32'"
                v-bind="attrs"
                v-on="on"
                @click="toggleStatus(item)"
              >
                <v-icon small>{{ item.status == 1 ? 'mdi-close-circle-outline' : 'mdi-check-circle-outline' }}</v-icon>
              </v-btn>
            </template>
            <span>{{ item.status == 1 ? 'Deactivate' : 'Activate' }}</span>
          </v-tooltip>
        </template>

        <template v-slot:no-data>
          <div class="empty-state">
            <v-icon size="44" color="#b0bec5">mdi-map-marker-radius-outline</v-icon>
            <div class="empty-text">No districts found</div>
          </div>
        </template>
      </v-data-table>
    </v-card>

    <!-- Create / Edit dialog -->
    <v-dialog v-model="dialog" max-width="480" persistent>
      <v-card>
        <div class="dlg-head">
          <div class="dlg-head-icon">
            <v-icon color="#fff">{{ oper === 'Add' ? 'mdi-map-marker-plus' : 'mdi-map-marker-radius' }}</v-icon>
          </div>
          <div>
            <div class="dlg-title">{{ oper === 'Add' ? 'New District' : 'Edit District' }}</div>
            <div class="dlg-sub">{{ oper === 'Add' ? 'Register a new district' : 'Update district details' }}</div>
          </div>
          <v-spacer />
          <v-btn icon small class="dlg-close" @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
        </div>
        <v-card-text class="pt-5">
          <v-form>
            <input type="hidden" v-model="district.id" />

            <div class="form-section">District Details</div>
            <v-row dense>
              <v-col cols="12">
                <v-text-field
                  v-model="district.district_name"
                  label="District Name"
                  outlined
                  dense
                  prepend-inner-icon="mdi-map-marker-outline"
                  required
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="district.region"
                  label="Region"
                  outlined
                  dense
                  prepend-inner-icon="mdi-earth"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions class="dlg-actions">
          <v-spacer />
          <v-btn text @click="dialog = false">Cancel</v-btn>
          <v-btn color="#0d2d63" dark :loading="saving" @click="guardar()">
            <v-icon left small>mdi-content-save-outline</v-icon>
            {{ oper === 'Add' ? 'Save District' : 'Save Changes' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" bottom right color="blue">{{ text }}</v-snackbar>
  </v-container>
</template>

<script>
import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL;

export default {
  name: 'DistrictVue',
  data() {
    return {
      search: '',
      dialog: false,
      oper: 'Add',
      saving: false,
      snackbar: false,
      text: '',
      districts: [],
      district: {
        id: '',
        district_name: '',
        region: '',
      },
      headers: [
        { text: 'No.', value: 'index', sortable: false },
        { text: 'District', value: 'district_name' },
        { text: 'Region', value: 'region' },
        { text: 'Status', value: 'status' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
    };
  },
  mounted() {
    this.mostrar();
  },
  methods: {
    mostrar() {
      axios.post(API_URL, { opcion: 42, op: 0 }).then((res) => {
        this.districts = res.data || [];
      });
    },
    formNuevo() {
      this.oper = 'Add';
      this.district = { id: '', district_name: '', region: '' };
      this.dialog = true;
    },
    formEditar(item) {
      this.oper = 'Update';
      this.district = { id: item.id, district_name: item.district_name, region: item.region };
      this.dialog = true;
    },
    guardar() {
      if (!this.district.district_name) {
        this.text = 'District name is required';
        this.snackbar = true;
        return;
      }
      this.saving = true;
      const payload = {
        opcion: 42,
        op: this.oper === 'Add' ? 1 : 11,
        id: this.district.id,
        district_name: this.district.district_name,
        region: this.district.region,
      };
      axios.post(API_URL, payload).then((res) => {
        this.saving = false;
        const row = Array.isArray(res.data) && res.data.length ? res.data[0] : {};
        if (row.ok === false) {
          this.text = row.msg || 'Save failed';
          this.snackbar = true;
          return;
        }
        this.dialog = false;
        this.mostrar();
        this.text = this.oper === 'Add' ? 'District added' : 'District updated';
        this.snackbar = true;
      }).catch(() => {
        this.saving = false;
        this.text = 'Save failed';
        this.snackbar = true;
      });
    },
    toggleStatus(item) {
      axios.post(API_URL, { opcion: 42, op: 12, id: item.id }).then(() => {
        this.mostrar();
        this.text = item.status == 1 ? 'District deactivated' : 'District activated';
        this.snackbar = true;
      });
    },
  },
};
</script>
